import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const bradentonBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Bradenton Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Bradenton Beach, FL. Sam\'s Tree Service handles dangerous coastal trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_bradenton_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Bradenton Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Bradenton Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we understand the unique demands of tree care 
     along the coastline of <strong>Bradenton Beach</strong>. Salt air, tropical storms, and 
     the constant exposure to Gulf winds accelerate tree stress and decay, turning once healthy 
     trees into serious hazards for nearby homes and structures. Our team is equipped to handle 
     the tough coastal jobs other companies avoid.`,

    `We specialize in <strong>hazardous and storm damaged tree situations</strong>
     salt weakened trunks, wind twisted canopies, leaning palms threatening seawalls or 
     buildings, and overgrowth pressing against rooftops and power lines. Every service is 
     tailored to the specific needs of your beachside property.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, professional tree care throughout 
     <strong>Bradenton Beach</strong> and the surrounding <strong>Anna Maria Island</strong> 
     communities keeping your property safe and your landscape healthy through every storm season.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Bradenton Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_BradentonBeach = () => <LocationPage config={bradentonBeachConfig} />;
export default Services_BradentonBeach;
